import { useEffect } from "react";
import PropostaSimplificada from "src/framework/layouts/Main/PropostaSimplificada";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Proposta Simplificada"

const PropostaSimplificadaPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <PropostaSimplificada />
        </div>
      </div>
    </div>
  );
};

export { PropostaSimplificadaPage };